import classnames from 'classnames2';
import React, { forwardRef } from 'react';

import { ITestProps } from '../utils/dataTest';

import linkStyles from './Link.module.scss';

export interface ILinkProps extends ITestProps, React.HTMLAttributes<HTMLElement> {
  /** Changes the HTML element used to display the component.
   * Href is not passed if as="button".
   */
  as?: 'a' | 'button';
  /** URL user will be directed to when they click the link. */
  href?: string;
  /** Text displayed inside the link */
  text: string;
  /** Determines if link should open in a new tab. */
  openInNewTab?: boolean;
  inputMode?: 'none' | 'search' | 'numeric' | 'text' | 'email' | 'tel' | 'url' | 'decimal';
  /** Callback for when the link is clicked by the user. */
  onClick?(event?);
}

export function createLink(displayName, linkStyle) {
  const LinkComponent: React.FC<ILinkProps> = (
    { as = 'a', text, dataTest, onClick, href, openInNewTab, ...rest },
    ref
  ) => {
    const HtmlElement = as;

    return (
      <HtmlElement
        ref={ref}
        data-test={dataTest}
        className={classnames(linkStyles.link, linkStyle)}
        onClick={onClick ? onClick : null}
        href={as === 'a' ? href : null}
        target={openInNewTab ? '_blank' : ''}
        {...rest}
      >
        {text}
      </HtmlElement>
    );
  };

  LinkComponent.displayName = displayName;

  return forwardRef(LinkComponent);
}

export const Link = {
  Quiet: createLink('Link.Quiet', linkStyles.quiet),
  Standard: createLink('Link.Standard', linkStyles.standard),
  Prominent: createLink('Link.Prominent', linkStyles.prominent)
};
